import api from '@/shared/api';
import { useQuery } from '@tanstack/react-query';
import { useIntl } from 'react-intl';
import handleHttpError from '@/shared/services/HandleHttpError';
import { LicenseQueryKey } from './queryKey';
export const useGetBillingCompany = (enabled = true) => {
    const intl = useIntl();
    return useQuery([LicenseQueryKey.BillingCompany], () => api.base.get('/api/company/GetBillingCompany').then(res => res.data), {
        enabled,
        onError: (apiError) => {
            handleHttpError(intl)(apiError);
        },
        retry: false,
    });
};
export default useGetBillingCompany;
